import { render, staticRenderFns } from "./FormDireccion.vue?vue&type=template&id=4578e1bb&scoped=true"
import script from "./FormDireccion.vue?vue&type=script&lang=js"
export * from "./FormDireccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578e1bb",
  null
  
)

export default component.exports